import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';

Vue.use(BootstrapVue);
